export default __webpack_public_path__ + "static/media/remove.f97a00ec.svg";